import React, { FC } from 'react';

const WelcomeBanner: FC = () => {
    return <h1>Welcome</h1>;
};

export default WelcomeBanner;
